import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  makeStyles,
  Card,
  CardContent,
  Button,
  Grid,
  Modal,
  Select,
  Typography,
  Snackbar,
  MenuItem
} from '@material-ui/core';
import Page from 'src/components/Page';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import data from './../product/ProductListView/data';
import ProductCard from '../product/ProductListView/ProductCard';
import { Alert } from '@material-ui/lab';
import { store } from 'src/_helpers';
import { userActions } from './../../_actions';
import { useNavigate } from 'react-router-dom';
// import config from '../../config/config.json';
import dotenv from 'dotenv';
import { authentication } from 'src/_reducers/authentication.reducer';
dotenv.config();

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  paper: {
    position: 'absolute',
    width: 600,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000'
  }
}));
const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: '#32325d',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4'
      }
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a'
    }
  }
};

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
  const top = 50 + rand();
  const left = 50 + rand();

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`
  };
}
const PaymentSection = () => {
  const navigate = useNavigate();
  const [modelOpen, setModelOpen] = React.useState(false);
  const [plan, setPlan] = React.useState('M');
  const [formData, setFormData] = React.useState();
  const [clientSecret, setClientSecret] = React.useState('');
  const [products] = useState(data);
  const stripe = useStripe();
  const classes = useStyles();
  const [error, setError] = useState(null);
  const [modalStyle] = React.useState(getModalStyle);
  const [planapi, setPlanapi] = React.useState('M');
  const [notifictionState, setNotifictionState] = React.useState({
    openNotification: false,
    vertical: 'top',
    horizontal: 'center',
    message: '',
    messageType: ''
  });
  const {
    vertical,
    horizontal,
    openNotification,
    message,
    messageType
  } = notifictionState;
  //   const stripe = useStripe();
  const elements = useElements();

  const handleClose = () => {
    setModelOpen(false);
  };
  const handleNotificationBarClose = () => {
    setNotifictionState({ ...notifictionState, openNotification: false });
  };

  async function stripeTokenHandler(data) {
    let { authentication } = store.getState();
    // console.log(
    //   'details1',
    //   process.env.REACT_APP_BASE_URL,
    //   authentication.user.email
    // );
    //
    const response = await fetch(process.env.REACT_APP_BASE_URL + '/V10/pay', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        email: authentication.user.email,
        token: authentication.user.token,
        // plan: data.plan,
        // ptype: data.type,
        amount: data.price
      })
    });

    const jRes = await response.json();
    // console.log('jres', jRes);
    if (jRes.results.hasOwnProperty('client_secret')) {
      setClientSecret(jRes.results['client_secret']);
      setModelOpen(true);
    } else {
      setNotifictionState({
        ...notifictionState,
        message: jRes.results[0].message,
        messageType: 'error',
        openNotification: true
      });
      if (jRes.rCode === 106) {
        console.log('details log out');
        userActions.logout();
        navigate('/', { replace: true });
      }
    }

    // .then(t =>{
    //   const s = await t.json();

    // const result = stripe.confirmCardPayment(clientSecret, {
    //   payment_method: {
    //     card: elements.getElement(CardElement),
    //     billing_details: {
    //       email: 'yy.imam@gmail.com'
    //     }
    //   }
    // });

    // }).then(s=> console.log("data2 ", s)).then(err => console.log("error ", err));

    // console.log('details', result);

    // return response.json();
  }
  // Handle real-time validation errors from the card Element.
  const handleChange = event => {
    if (event.error) {
      setError(event.error.message);
    } else {
      setError(null);
    }
  };

  const ChangePlanc = e => {
    setPlan(e.target.value);
  };

  // Handle form submission.
  const handleSubmit = async event => {
    let { authentication } = store.getState();
    event.preventDefault();
    const result = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement),
        billing_details: {
          email: authentication.user.email
        }
      }
    });
    if (result.hasOwnProperty('error')) {
      setModelOpen(false);
      setNotifictionState({
        ...notifictionState,
        message: result.error.message,
        messageType: 'error',
        openNotification: true
      });
    } else {
      setModelOpen(false);
      var apiKey = authentication.user.apiKey;
      let t = { ...result.paymentIntent, formData, apiKey };
      // console.log('details', t);
      var d = {
        token: authentication.user.token,
        data: JSON.stringify(t),
        email: authentication.user.email
      };
      const response = await fetch(
        process.env.REACT_APP_BASE_URL + '/V10/pay/confirm-payment',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(d)
        }
      )
        .then(t => t.json())
        .then(t => {
          return t;
        })
        .catch(err => console.log(err));
      // console.log('reponce', response);
      if (response.results.answer === 'created successfully') {
        const response2 = await fetch(
          process.env.REACT_APP_BASE_URL + '/V10/user/subcribtion',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              email: authentication.user.email,
              token: authentication.user.token,
              plan: formData.plan,
              subscriptionType: formData.type
            })
          }
        )
          .then(t => t.json())
          .then(t => {
            return t;
          })
          .catch(err => console.log(err));
        // console.log('response2', response2, formData);
        setNotifictionState({
          ...notifictionState,
          message: 'Tansation has been made successfully',
          messageType: 'success',
          openNotification: true
        });
      } else {
        setNotifictionState({
          ...notifictionState,
          message: response.results,
          messageType: 'error',
          openNotification: true
        });
      }
    }

    // const card = elements.getElement(CardElement);
    // const result = await stripe.createToken(card);
    // if (result.error) {
    //   console.log("data error", result)
    //   // Inform the user if there was an error.
    //   setError(result.error.message);
    // } else {
    //   setError(null);
    //   // Send the token to your server.
    // stripeTokenHandler("result.token");
    // console.log("data success", result)
    // }
  };

  const handleClick = async data => {
    setFormData(data);
    stripeTokenHandler(data);
  };

  return (
    <Page className={classes.root} title="Payment">
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={openNotification}
        onClose={handleNotificationBarClose}
        key={vertical + horizontal}
        autoHideDuration={6000}
      >
        <Alert onClose={handleNotificationBarClose} severity={messageType}>
          {message}
        </Alert>
      </Snackbar>
      <Modal
        open={modelOpen}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div style={modalStyle} className={classes.paper}>
          <Container maxWidth={false}>
            <Card>
              {/*  */}
              <CardContent style={{ width: '100%' }}>
                {/* <Toolbar /> */}
                <Box mt={3}>
                  <form onSubmit={handleSubmit}>
                    <div className="form-row">
                      <label
                        htmlFor="card-element"
                        style={{ fontSize: '25px', fontWeight: 'bold' }}
                      >
                        Credit or debit card
                      </label>
                      <div style={{ marginTop: '15px', marginBottom: '15px' }}>
                        <CardElement
                          id="card-element"
                          options={CARD_ELEMENT_OPTIONS}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="card-errors" role="alert">
                        {error}
                      </div>
                    </div>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      style={{ width: '100%' }}
                    >
                      Pay
                    </Button>
                    {/* <button type="submit">Submit Payment</button> */}
                  </form>
                </Box>
              </CardContent>
              {/*  */}
            </Card>
          </Container>
        </div>
      </Modal>
      <Container maxWidth={false}>
        <Card>
          <CardContent>
            <Box p={2}>
              <Grid container justify="center" alignItems="center" spacing={3}>
                <Grid className={classes.statsItem} item>
                  <Typography
                    align="center"
                    color="textPrimary"
                    gutterBottom
                    variant="h4"
                  >
                    Select Plan
                  </Typography>
                </Grid>
                <Grid className={classes.statsItem} item>
                  <Select
                    onChange={ChangePlanc}
                    labelId="label"
                    id="select"
                    value={plan}
                  >
                    <MenuItem value="M">Core Plan</MenuItem>
                    <MenuItem value="Y">Geo Plan</MenuItem>
                  </Select>
                </Grid>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Container>
      <Container maxWidth={false}>
        <Box mt={3}>
          <Grid container spacing={3}>
            {products.map((product, index) => (
              <Grid item key={index} lg={4} md={6} xs={12}>
                <ProductCard
                  key={index}
                  className={classes.productCard}
                  product={product}
                  plan={plan}
                  handleClick={handleClick}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box mt={3} display="flex" justifyContent="center">
          {/* <Pagination
          color="primary"
          count={3}
          size="small"
        /> */}
        </Box>
      </Container>
      <Container maxWidth={false}></Container>
    </Page>
  );
};

export default PaymentSection;
